<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        url="repairRegistrationReports/page"
        hide-show-hide-btn>
      <template #adSearch>
        <vm-search label="维修登记编号">
          <el-input v-model="filter.billNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model="filter.customerName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="客户单号">
          <el-input v-model="filter.customerOrderNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="生产厂家">
          <el-input v-model="filter.manufacturer" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="编辑人">
          <el-input v-model="filter.editor" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search-date
            label="检测日期"
            :start-time.sync="filter.repairDateStart"
            :end-time.sync="filter.repairDateEnd"/>
      </template>
      <el-table-column prop="billNo" label="维修登记编号" align="center" width="110">
        <template v-slot="scope">
          <a @click="$refs.editPage.open(scope.row, false, true, true)">{{scope.row.billNo}}</a>
        </template>
        <template #header>
          <el-input v-model.trim="filter.billNo" placeholder="维修登记编号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户名称" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.customerName" placeholder="客户名称" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="customerOrderNo"
          label="客户单号"
          align="center"
          width="160"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.customerOrderNo" placeholder="客户单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="manufacturer"
          label="生产厂家"
          align="center"
          width="120"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.manufacturer" placeholder="生产厂家" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="editor" label="编辑人" align="center" width="120">
        <template #header>
          <el-input v-model.trim="filter.editor" placeholder="编辑人" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="receiptTime" label="接收时间" align="center" width="120"/>
      <el-table-column prop="updateTime" label="生成日期" align="center" width="120">
        <template #header>
          <el-date-picker
              v-model="filter.updateTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="生成日期"
              @change="$refs.vmTable.handleSearchClick();"/>
        </template>
      </el-table-column>
      <el-table-column
          v-if="editAuth"
          label="操作"
          align="center"
          fixed="right"
          width="150px">
        <template v-slot="scope">
          <el-button type="success" @click="$refs.editPage.open(scope.row, false, true, false)">标准编辑</el-button>
          <el-button type="primary" @click="$refs.reportPageDS.open(scope.row, false, true, false)">DS编辑</el-button>
          <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <repair-registration-report ref="editPage" @save-success="getList(-1)"/>
    <repair-registration-report-d-s ref="reportPageDS" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmSearchDate from "@/components/VmSearchDate.vue";
  import RepairRegistrationReport from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationReport.vue";
  import VmTable from "@/components/v2/VmTable";
  import VmSearch from "@/components/v2/VmSearch";
  import RepairRegistrationReportDS from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationReportDS";


  export default {
    name: "RepairRegistrationReportList",
    components: {RepairRegistrationReportDS, VmSearch, VmTable, RepairRegistrationReport, VmSearchDate},
    data() {
      return {
        editAuth: true,
        filter: {
          billNo: "",
          manufacturer: "",
          customerName: "",
          customerOrderNo: "",
          editor: "",
          repairDate: "",
          repairDateStart: "",
          repairDateEnd: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleDelete(row) {
        this.$confirm(`确定删除单据 ${row.billNo} 吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "repairRegistrationReports", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
